import React from "react"
import { Button } from "antd"

interface BulkSelectionBarProps {
  count: number
  onAdd: () => void
  onRemove: () => void
  onClear: () => void
}

/**
 * Stands in for the Projects header's search and New while projects are
 * ticked: the count, the two member actions (Add is the one solid button) and
 * Clear. One line, never wrapping.
 */
const BulkSelectionBar: React.FC<BulkSelectionBarProps> = ({
  count,
  onAdd,
  onRemove,
  onClear,
}) => (
  <div className="flex flex-nowrap items-center gap-2">
    <span className="whitespace-nowrap text-gray-600">
      {count === 1 ? "1 project selected" : `${count} projects selected`}
    </span>
    <Button onClick={onRemove}>Remove members…</Button>
    <Button type="primary" onClick={onAdd}>
      Add members…
    </Button>
    <Button type="text" onClick={onClear}>
      Clear
    </Button>
  </div>
)

export default BulkSelectionBar
